import React from 'react'

const AdditionalComponent = (props) => {
    return (
        <div className={props.containerCss}>
            {props.content}
        </div>
    )
}

export default AdditionalComponent